<div class="debug-page">
    <h2 class="debug-title">Debug chiffres utiles Parc</h2>

    <div class="debug-card">
        <div class="debug-controls">
            <div class="control-group">
                <label class="control-label" for="parc-select">Parc</label>
                <select id="parc-select" class="field-select" [ngModel]="parcIdSelectionne()" (ngModelChange)="parcIdSelectionne.set($event)">
                    <option [ngValue]="null">— Sélectionner un parc —</option>
                    @for (parc of parcs(); track parc.id) {
                        <option [ngValue]="parc.id">{{ parc.libelle }}</option>
                    }
                </select>
            </div>

            <div class="control-group">
                <label class="control-label" for="parc-id-manuel">ID parc (manuel)</label>
                <input
                    id="parc-id-manuel"
                    class="field-input"
                    type="number"
                    placeholder="ex: 37287"
                    [ngModel]="parcIdSelectionne()"
                    (ngModelChange)="parcIdSelectionne.set($event === null || $event === '' ? null : +$event)"
                />
            </div>

            <div class="control-group">
                <label class="control-label">&nbsp;</label>
                <button class="btn-charger" [disabled]="chargement() || parcIdSelectionne() === null" (click)="chargerDonnees()">
                    @if (chargement()) {
                        <span class="material-symbols-outlined spin">progress_activity</span>
                    } @else {
                        <span class="material-symbols-outlined">download</span>
                    }
                    Appeler l'API
                </button>
            </div>
        </div>

        @if (erreur()) {
            <div class="result-erreur">
                <span class="material-symbols-outlined">error</span>
                {{ erreur() }}
            </div>
        }

        @if (reponse(); as r) {
            <div class="result-bloc">
                <div class="result-header">
                    <span class="material-symbols-outlined">table_rows</span>
                    Valeurs formatées
                </div>
                <table class="tableau-chiffres">
                    <tbody>
                        <tr>
                            <td class="col-champ">puissance</td>
                            <td class="col-brut">{{ r.puissance }}</td>
                            <td class="col-formatte">{{ r.puissance | puissanceUnite }}</td>
                        </tr>
                        <tr>
                            <td class="col-champ">energie_journaliere</td>
                            <td class="col-brut">{{ r.energie_journaliere }}</td>
                            <td class="col-formatte">{{ r.energie_journaliere | energieUnite }}</td>
                        </tr>
                        <tr>
                            <td class="col-champ">energie_veille</td>
                            <td class="col-brut">{{ r.energie_veille }}</td>
                            <td class="col-formatte">{{ r.energie_veille | energieUnite }}</td>
                        </tr>
                        <tr>
                            <td class="col-champ">energie_cumulee</td>
                            <td class="col-brut">{{ r.energie_cumulee }}</td>
                            <td class="col-formatte">{{ r.energie_cumulee | energieUnite }}</td>
                        </tr>
                        <tr>
                            <td class="col-champ">co2_evite</td>
                            <td class="col-brut">{{ r.co2_evite }}</td>
                            <td class="col-formatte">{{ r.co2_evite | co2Unite }}</td>
                        </tr>
                        <tr>
                            <td class="col-champ">revenus_cumules</td>
                            <td class="col-brut">{{ r.revenus_cumules }}</td>
                            <td class="col-formatte">{{ r.revenus_cumules | deviseUnite }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            @if (detailLignes().length > 0) {
                <div class="result-bloc">
                    <div class="result-header">
                        <span class="material-symbols-outlined">list_alt</span>
                        Détail par installation ({{ detailLignes().length }})
                    </div>
                    <div class="tableau-wrapper">
                        <table class="tableau-chiffres">
                            <thead>
                                <tr>
                                    <th class="col-champ col-sortable" (click)="trierParDetail('nom')">
                                        Installation
                                        <span class="sort-icon material-symbols-outlined" [class.active]="sortEtatDetail()?.colonne === 'nom'">{{ iconeSortDetail('nom') }}</span>
                                    </th>
                                    <th class="col-brut col-sortable" (click)="trierParDetail('totalProduction')">
                                        total_production
                                        <span class="sort-icon material-symbols-outlined" [class.active]="sortEtatDetail()?.colonne === 'totalProduction'">{{ iconeSortDetail('totalProduction') }}</span>
                                    </th>
                                    <th class="col-brut col-sortable" (click)="trierParDetail('totalRevenus')">
                                        total_revenus
                                        <span class="sort-icon material-symbols-outlined" [class.active]="sortEtatDetail()?.colonne === 'totalRevenus'">{{ iconeSortDetail('totalRevenus') }}</span>
                                    </th>
                                    <th class="col-brut col-sortable" (click)="trierParDetail('lastValueRefPuissance')">
                                        last_value_ref_puissance
                                        <span class="sort-icon material-symbols-outlined" [class.active]="sortEtatDetail()?.colonne === 'lastValueRefPuissance'">{{ iconeSortDetail('lastValueRefPuissance') }}</span>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                @for (ligne of detailLignesTriees(); track ligne.idInstallation) {
                                    <tr>
                                        <td class="col-champ">{{ ligne.nom }} ({{ ligne.idInstallation }})</td>
                                        <td class="col-brut">{{ fmt(ligne.totalProduction, 0) }}</td>
                                        <td class="col-brut">{{ fmt(ligne.totalRevenus) }}</td>
                                        <td class="col-brut">{{ fmt(ligne.lastValueRefPuissance) }}</td>
                                    </tr>
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            }

            <div class="result-bloc">
                <div class="result-header">
                    <span class="material-symbols-outlined">data_object</span>
                    Réponse brute (JSON)
                </div>
                <pre class="result-json">{{ reponseJson }}</pre>
            </div>
        }
    </div>
</div>
